import api from './index';

// 蛋白质分析接口类型定义
export interface ProteinAnalysisRequest {
  sequence: string;
  name?: string;
}

// 从后端 /tasks 端点获取的任务类型
export interface ProteinAnalysisTask {
  module_id: string;
  module_name: string;
  endpoint: string;
  method: string[];
  name: string;
  description: string;
  tags: string[];
  service_type: string;
}

export interface TMPredictionRequest {
  sequence: string;
  name?: string;
}

export interface SignalPredictionRequest {
  sequence: string;
  name?: string;
  organism?: string;
}

export interface ProteinBasicAnalysisTask {
  id: string;
  name: string;
  description: string;
}

// 蛋白质分析服务
export const proteinService = {
  /**
   * 获取所有可用的蛋白质分析任务
   */
  getAnalysisTasks: async (): Promise<ProteinAnalysisTask[]> => {
    console.log('🚀 开始请求任务列表...');
    // 注意：api 响应拦截器已直接返回 data，本处拿到的就是数组数据
    const data = await api.get<ProteinAnalysisTask[]>('/protein_analysis/tasks');
    console.log('📥 收到任务列表:', Array.isArray(data) ? data.length : 'not array', '个');
    return Array.isArray(data) ? data : [];
  },
};

export default proteinService;
